import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installAcademicYearHeader } from './academicYear';

// Secili akademik yili tum isteklere X-Academic-Year olarak ekle.
// App render edilmeden once kurulmali; ilk istekler de yila kapsansin.
installAcademicYearHeader();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

